import dayjs from 'dayjs';

// 현재 달의 시작 날짜 받아오기
export const getToday = () => {
	return new Date().toISOString().slice(0, 8) + '01';
};
// 현재 달의 마지막 날짜 받아오기
export const getLastDay = () => {
	return new Date().toISOString().slice(0, 8) + dayjs().daysInMonth();
};
